import type { ReactNode } from 'react'

interface PageHeaderProps {
  title: string
  /** Plain text, or nodes when the subtitle needs a link. */
  description?: ReactNode
  /** Rendered to the left of the title — used for layout/location preview thumbnails. */
  media?: ReactNode
  actions?: ReactNode
}

export function PageHeader({ title, description, media, actions }: PageHeaderProps) {
  return (
    <div className="mb-6 flex items-start justify-between gap-4">
      <div className="flex min-w-0 items-center gap-3">
        {media}
        <div className="min-w-0">
          <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
          {description && (
            <p className="mt-1 text-sm text-muted-foreground">{description}</p>
          )}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  )
}
